import type { Handleiding } from './soort';

export const pt: Handleiding = {
  code: 'pt',
  titel: 'Manual',
  inleiding:
    'O Ask Gio Tolk traduz uma conversa entre duas pessoas que não falam a mesma língua. Aqui em baixo está o que cada botão faz.',
  knop: 'Abrir o manual',
  sluiten: 'Fechar',
  groepGebruik: 'Participar',
  groepBeheer: 'Configurar e gerir',
  delen: [
    {
      titel: 'Falar',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Fala',
          uitleg:
            'Toca uma vez para começar. A gravação para sozinha assim que ficas calado durante pouco mais de um segundo, ou se tocares outra vez. Ao fim de um minuto para de qualquer maneira.',
        },
        {
          kop: 'Um som de cada vez',
          uitleg:
            'Enquanto a aplicação fala, não podes gravar. E enquanto gravas, uma tradução que chega espera até acabares. Caso contrário o teu microfone grava a aplicação e julga que foste tu a dizê-lo.',
        },
        {
          kop: 'Escreve aqui a tua mensagem',
          uitleg:
            'Funciona a par da fala e passa pela mesma tradução. Enter envia, shift com enter faz uma linha nova.',
        },
        {
          kop: 'Tempo para corrigir',
          uitleg:
            'Aqui defines quantos segundos tens para reler a tua frase transcrita antes de sair. A zero sai logo.',
        },
        {
          kop: 'Rever e enviar sempre tu próprio',
          uitleg:
            'Sem relógio. Cada frase espera que carregues em enviar. Para quem quer rever cada frase.',
        },
        {
          kop: 'Reproduzir a tradução logo',
          uitleg: 'Está ligado. Desliga-o se preferires ler primeiro e decidir tu quando ouves.',
        },
      ],
    },
    {
      titel: 'Ler as mensagens',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'O que está em grande',
          uitleg:
            'O que está na TUA língua está em grande. Na tua própria frase é o teu texto original, para poderes verificar se a aplicação te percebeu bem. Numa frase do outro é a tradução.',
        },
        {
          kop: 'Abrir o original ou a tradução',
          uitleg: 'A outra língua está por baixo, fechada. Toca na linha para a abrir.',
        },
        {
          kop: 'O triângulo',
          uitleg: 'Volta a reproduzir a tradução.',
        },
        {
          kop: 'A cabeça a falar',
          uitleg:
            'Reproduz a gravação do outro. Só aparece numa mensagem FALADA e só se «envia também a tua própria voz» estiver ligado. Uma mensagem escrita não tem gravação.',
        },
      ],
    },
    {
      titel: 'Botões no topo do ecrã',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Menos e mais',
          uitleg: 'Torna o texto mais pequeno ou maior. Em cinco passos, e fica guardado.',
        },
        {
          kop: 'O microfone',
          uitleg: 'Esconde o botão de falar se só escreves. Assim ganhas espaço.',
        },
        {
          kop: 'O teclado',
          uitleg:
            'Esconde a caixa de texto. Fica sempre um dos dois ligado, senão já não podias dizer nada.',
        },
      ],
    },
    {
      titel: 'Entrar',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Que língua falas',
          uitleg:
            'Esta escolha determina também a língua dos botões e dos avisos. Cada um de vocês vê portanto um ecrã diferente, e é essa a intenção.',
        },
        {
          kop: 'A tua voz na tradução',
          uitleg:
            'Escolhe se soas a homem ou a mulher. Isto pertence a TI, não à sala: cada participante escolhe em separado.',
        },
        {
          kop: 'Autorização para o microfone',
          uitleg:
            'O navegador pede-a à entrada. Se disseres que não, ainda podes escrever. Dar a autorização mais tarde é possível através do cadeado na barra de endereços.',
        },
      ],
    },
    {
      titel: 'Em baixo, fechado',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: 'Lista de palavras de recurso',
          uitleg:
            'Palavras que têm de ser sempre traduzidas da mesma maneira: nomes, termos técnicos, marcas. Vale para toda a sala.',
        },
        {
          kop: 'Alterar as definições',
          uitleg:
            'Língua, voz, tom e correção ortográfica também se mudam A MEIO da conversa. O que mudares aqui vale logo para os dois.',
        },
      ],
    },
    {
      titel: 'Começar uma conversa',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: 'Nome da conversa',
          uitleg: 'Pode ficar vazio. Só aparece no topo do teu ecrã, para saberes com quem falas.',
        },
        {
          kop: 'Falante 1 e falante 2',
          uitleg:
            'As duas línguas desta conversa. Quem entra primeiro fica no primeiro lugar. Ainda podes trocar as línguas mais tarde.',
        },
        {
          kop: 'Tom da tradução',
          uitleg:
            'À esquerda escolhes tratamento por tu ou por si, à direita o ambiente: neutro, amigável, profissional, oficial ou de casal. Sem orientação o modelo escolhe quase sempre a forma formal, e numa conversa normal isso soa distante.',
        },
        {
          kop: 'Envia também a tua própria voz',
          uitleg:
            'O outro pode ouvir a tua gravação além da tradução. Prático para aprender uma língua. Desliga isto numa conversa delicada: quem recebe a gravação pode guardá-la.',
        },
        {
          kop: 'Corrige os erros no teu próprio texto',
          uitleg:
            'Está ligado. Desliga-o para veres o que o modelo percebeu mesmo. Se aparecer uma frase estranha, sabes se foi mal percebida ou bem percebida e depois alisada.',
        },
        {
          kop: 'Com código PIN',
          uitleg:
            'Passa o código de viva voz, não na mesma mensagem que o link. Isso protege contra um link reencaminhado.',
        },
        {
          kop: 'O código QR',
          uitleg:
            'Manda o outro digitalizá-lo, ou envia o link. Uma sala expira sozinha ao fim de quatro horas.',
        },
      ],
    },
    {
      titel: 'O que acontece à tua conversa',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: 'O texto não é guardado',
          uitleg:
            'O que vocês dizem não vai para a base de dados. Apenas quando e quanto se falou, para os custos.',
        },
        {
          kop: 'As gravações desaparecem sozinhas',
          uitleg: 'O áudio fica dez minutos na memória e depois vai-se embora.',
        },
        {
          kop: 'A sala expira',
          uitleg: 'Quatro horas depois de ser criada. Depois o link deixa de funcionar.',
        },
        {
          kop: 'Há um orçamento',
          uitleg:
            'Por sala e por mês. Se encher, a aplicação para de traduzir e diz isso. Não é uma avaria.',
        },
      ],
    },
  ],
};
